import React from 'react';
import LoginComponent from '../../../components/public/Login/Login.component';
import RecoverPassComponent from '../../../components/public/RecoverPass/RecoverPass.component';
import SigninComponent from '../../../components/public/Signin/Signin.component';

const Auth = ({visibleLogin,visibleSignin,visibleForget,onClickLogin,onClickSingIn,onClickForget}) => {


    
        return (
          <>
            {visibleLogin && (
              <LoginComponent
                visibleLogin={visibleLogin}
                onCloseLogin={() => onClickLogin()}
                onOpenSignin={() => onClickSingIn()}
                onOpenForgotePass={() => onClickForget()}
    
              />
            )}
            {visibleSignin && (
              <SigninComponent
                visibleSignin={visibleSignin}
                onCloseSignin={() => onClickSingIn()}
                onSignin={() => onClickSingIn()}
                onLogin={() => onClickLogin()}
              />
            )}
            {visibleForget && (
              <RecoverPassComponent
                visibleForget={visibleForget}
                onCloseForget={() => onClickForget()}
                onRecover={() => onClickForget()}
              />
            )}
    
          </>
    
        )
    
    
    
}

export default Auth;
